module.exports = __webpack_public_path__ + "static/media/11.1939c1b7.png";